import { Observable } from 'rxjs'

export class ShowHidePasswordComponent {
    constructor() {
        this.iconElements = document.querySelectorAll('[data-toggle="showHidePassword"]');

        //initialize events
        this.init();
    }

    init() {
        if(this.iconElements) {
            Array.prototype.forEach.call(this.iconElements, icon => {
                let iconClickStream = Observable.fromEvent(icon, 'click')
                iconClickStream
                    .debounceTime(200)
                    .subscribe((event) => {
                        const iconElement = event.target;

                        if(iconElement) {
                            const inputElement = iconElement.nextElementSibling;
                            
                            if(inputElement) {
                                if(inputElement.getAttribute('type') === 'password') {
                                    iconElement.innerText = "visibility_off"
                                    inputElement.setAttribute('type', 'text')
                                }else {
                                    iconElement.innerText = "visibility"
                                    inputElement.setAttribute('type', 'password')
                                }
                            }
                        }
                        
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/form/showHidePassword.component.js